namespace Matrix.Workflow {
    export interface WorkflowMapBatchUpdateRequest extends Serenity.ServiceRequest {
        MapIdList?: number[];
        WorkflowCode?: string;
    }
}
